import {
  Hero,
  Features,
  PopularProducts,
  Touch,
  Banner,
  Story,
} from "@/components/Pages/HomePage";
import Head from "next/head";
import Link from "next/link";
import ShopTheLook from "@/components/Pages/HomePage/components/ShopTheLook/ShopTheLook";
import { Image } from "@nextui-org/react";
import LookingFor from "@/components/Pages/HomePage/components/LookingFor";
import ShopTheLook2 from "@/components/Pages/HomePage/components/ShopTheLook2";
import FadeInSection from "@/components/Shares/FadeInSection";
import SEOHead from "@/components/Shares/SEOHead/SEOHead";
import OrganizationSchema from "@/components/Shares/StructuredData/OrganizationSchema";

export default function Home() {
  return (
    <>
      <SEOHead
        title="Furniture & Homewares Online at Beautiful Prices"
        description="Discover beautiful furniture and homewares at affordable prices. Shop now at Priceworth Furniture. Free delivery Australia wide on quality furniture and home decor."
        canonical="https://www.priceworth.com.au"
        keywords="furniture, homewares, online furniture store, Australian furniture, affordable furniture, home decor, furniture delivery Australia"
      />
      <OrganizationSchema />
      <h1 className="sr-only">
        Furniture & Homewares Online at Beautiful Prices
      </h1>
      <div className="w-full inline-flex flex-nowrap overflow-hidden">
        <div className="flex animate-infinite-scroll">
          <Link
            href="/sale"
            className="flex items-center justify-center flex-shrink-0"
          >
            <img
              src="/sale-bar.png"
              alt="Sale banner - Shop furniture at discounted prices"
              width={3713}
              height={41}
              className="max-w-none"
              loading="lazy"
            />
          </Link>
          <Link
            href="/sale"
            className="flex items-center justify-center flex-shrink-0"
          >
            <img
              src="/sale-bar.png"
              alt="Sale banner - Shop furniture at discounted prices"
              width={3713}
              height={41}
              className="max-w-none"
              loading="lazy"
            />
          </Link>
          <Link
            href="/sale"
            className="flex items-center justify-center flex-shrink-0"
          >
            <img
              src="/sale-bar.png"
              alt="Sale banner - Shop furniture at discounted prices"
              width={3713}
              height={41}
              className="max-w-none"
              loading="lazy"
            />
          </Link>
        </div>
      </div>
      {/* <div>
        <Link href="/sale">
          <Image src="./40off.webp" alt="free delivery" radius="none" />
        </Link>
      </div> */}
      <Hero />
      {/* <ShopTheLook /> */}
      <FadeInSection>
        <ShopTheLook2 />
      </FadeInSection>
      {/* <Features /> */}
      {/* <Hero2 /> */}
      <FadeInSection>
        <LookingFor />
      </FadeInSection>
      <FadeInSection>
        <PopularProducts />
      </FadeInSection>
      <FadeInSection>
        <Touch />
      </FadeInSection>
      {/* <Review /> */}
      {/* <Story /> */}
      {/* <Banner /> */}
    </>
  );
}
